import { Container } from '@pixi/react'
import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { gameConfig } from '../../config'
import { winningPanelService } from '../../domain/winning/service/winningPanelService'
import { GrayBackground } from '@slot-nx/core'

export const WinningPanel = () => {
  const winningFrameRef = useRef<PixiContainer>()
  const winningRef = useRef<PixiContainer>()

  useEffect(() => {
    winningPanelService.winningPanel = winningFrameRef.current as PixiContainer
  }, [])

  return (
    <Container
      name="winningPanel"
      visible={false}
      ref={(el: PixiContainer | null) => {
        winningFrameRef.current = el as PixiContainer
      }}
      x={gameConfig.resolution.width / 2}
      y={gameConfig.resolution.height / 2}
      eventMode="static"
      cursor="pointer"
    >
      <GrayBackground name="winningPanelPopup" />
      <Container
        name="spineWinContainer"
        ref={(el: PixiContainer | null) => {
          winningRef.current = el as PixiContainer
        }}
      />

      <Container
        name="winAmount"
        y={95}
      />
    </Container>
  )
}
